import { FC } from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';

type HeaderProps = {
  showDocsLink?: boolean;
  showPortalLink?: boolean;
  showLoginLink?: boolean;
  loginLabel?: string;
};

const Header: FC<HeaderProps> = ({
  showDocsLink = true,
  showPortalLink = true,
  showLoginLink = true,
  loginLabel = 'Developer Login',
}) => {
  return (
    <div className="topbar">
      <div className="topbar-inner">
        <Link to="/" className="brand-link" aria-label="AfricaWeather Home">
          <img src="/images/weblogowhite.png" alt="AfricaWeather" className="brand-logo" />
        </Link>
        <div style={{ flex: 1 }} />
        {showDocsLink && <a href="/docs" className="header-btn secondary">Docs</a>}
        {showPortalLink && <a href="/portal" className="header-btn secondary">Portal</a>}
        {showLoginLink && <a href="/login" className="header-btn primary">{loginLabel}</a>}
      </div>
    </div>
  );
};

export default Header;
